<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vMzlOW/images/e9781439616864_cover.jpg?1684514529003" alt="This image is the cover for the book Grand Rapids, Postcard History"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Grand Rapids, Postcard History
      </h1>
      <p class="bookDescription body article font2">
        <p>In the years between 1890 and 1950, the city of Grand Rapids grew from a small Midwestern town of great potential into a large and important commercial and manufacturing center. With the growth of the city and its population came a large variety of activities, commercial and recreational, which were happily recorded in a huge array of postcards produced by both local and national printers. These cards and the moments they preserve provide a unique glimpse into the life and growth of Grand Rapids.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Thomas R. Dilley
      </h2>
      
      <p class="authorDescription body article">Thomas R. Dilley is a lifelong resident of Grand Rapids, where he lives with his wife, Debra, daughter, Sarah, and basset hound, Ruthie. His 40-year interest in the history of his hometown is refl ected in his avid collection of the postcards in Grand Rapids: Community and Industry, as well as a large assortment of other materials documenting the history of the city. He is a trustee of the Grand Rapids Historical Society and is the author of Grand Rapids in Vintage Postcards: 1890-1940.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?db80586c